import React, { useState, useEffect } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import DataTable from "../../Student/Reusablecomponents/DataTable/DataTable";
import Loading from "../../Student/Reusablecomponents/Loading";
import InternetChecking from "../../Student/Reusablecomponents/Network";
import CopyRight from "../../Student/Reusablecomponents/Copyright";
import {
  Assessmentdate,
  Year,
  Month,
} from "../../Student/Reusablecomponents/RegularFunctions";
import DropdownValues from "../../Student/Reusablecomponents/DropDownValues";

const AttendanceReport = () => {
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const USYear = useSelector((state) => state.SelecYearData.SYear);
  const TesType = useSelector((state) => state.TesTypedata.TesType);
  const Filters = JSON.parse(localStorage.getItem("DiFFInput"));
  const PrincipleTeachers = useSelector(
    (state) => state.PrincipalTeacherDashboarData
  );
  const [GetAssessmentdate, SetGetAssessmentdate] = useState(
    Filters?.ContestCreationId || PrincipleTeachers?.CCID
  );
  const [GetYear, SetGetYear] = useState();
  const [Month, SetMonth] = useState("1");
  const [StudentsAttendance, SetStudentsAttendance] = useState();
  const [Load, SetLoad] = useState(false);

  const MonthOptions = [
    { display: "January", value: "1" },
    { display: "February", value: "2" },
    { display: "March", value: "3" },
    { display: "April", value: "4" },
    { display: "May", value: "5" },
    { display: "June", value: "6" },
    { display: "July", value: "7" },
    { display: "August", value: "8" },
    { display: "September", value: "9" },
    { display: "October", value: "10" },
    { display: "November", value: "11" },
    { display: "December", value: "12" },
  ];

  const columns = [
    { name: "Student Id", selector: "studentId", sortable: true },
    { name: "Name", selector: "studentName", sortable: true },
    { name: "Class", selector: "class", sortable: true },
    { name: "Tests Taken", selector: "testsTaken", sortable: true },
    { name: "Tests Taken %", selector: "testsTakenPercentage", sortable: true },
  ];

  useEffect(() => {
    if (Month) GetSchoolAttendanceReport();
  }, [Month]);

  const GetSchoolAttendanceReport = async () => {
    SetLoad((prev) => !prev);
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/School/GetStudentAttendanceReport?SchoolId=134065&Month=${Month}&Year=${USYear?.value}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        SetStudentsAttendance(res.data);
        SetLoad((prev) => !prev);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <div className="TeacherBgImage">
        <InternetChecking />
        <div className="TFilters dflex alignitems" style={{ gap: "10px" }}>
          {/* <Assessmentdate Institute={items?.instituteId} Postdate={SetGetAssessmentdate} className="NCLDropdown" PostYear={new Date().getFullYear()} Asstype={TesType} selected={GetAssessmentdate?.code} /> */}
          <Year PostYear={SetGetYear} className="NCLDropdown" />
          {/* <Month PostMonth={SetGetMonth} className="NCLDropdown" /> */}
          <DropdownValues
            className="NCLDropdown"
            selectoption={Month}
            options={MonthOptions}
            onChange={(e) => SetMonth(e.target.value)}
          />
        </div>
        <div className="Card mt-3">
          {StudentsAttendance ? (
            <>
              <DataTable
                data={StudentsAttendance}
                columns={columns}
                Dropdownvalues={["10", "15", "20"]}
                className="NCLDataTable"
              />
            </>
          ) : (
            <div className="NoData-Message">
              {process.env.REACT_APP_Nodata_Found}
            </div>
          )}
        </div>
        <CopyRight />
      </div>
      {Load && <Loading />}
    </>
  );
};
export default AttendanceReport;
